import { useEffect, useState } from "react";
import { _PayrollEntity, _single, _ThirdLoanEntity } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";

export const ThirdLoanEntity = () => {
    const { instance, setLista, setBean, bean, lista, handleChange } = useDataBean(_ThirdLoanEntity);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const head = [
        { title: 'ID', property: 'IDThirdLoanEntity', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Contacto', property: 'ContactName', visible: true },
        { title: 'Organización', property: 'AccountEntityName', visible: true },
        { title: 'Habilidado', property: 'Enabled', visible: true },
    ]

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getThirdLoanEntityCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const updateIten = () => {
        instance.updateThirdLoanEntity(bean).then(
            (resp) => {
                getLista()
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteThirdLoanEntity(bean.IDThirdLoanEntity).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    const create = () => {
        setBean({
            Enabled: false,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Entidades con Créditos Administrados" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Entidades con Créditos Administrados" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Entidades con Créditos Administrados` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Entidades con Créditos Administrados" >
            <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar {bean.IDThirdLoanEntity} - {bean.Name}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateIten}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" className="form-control" name="Name" value={bean.Name} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDAccountEntity} label="Organización" onChange={(e) => { setBean({ ...bean, "IDAccountEntity": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <AccountEditor idAccount={bean.IDAccountContact} label="Contacto" onChange={(e) => { setBean({ ...bean, "IDAccountContact": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch estado={bean.Enabled} eventChange={(e) => { setBean({ ...bean, "Enabled": e }) }} label="¿Habilitado?" />
                        </div>
                    </div>
                </Modal>
            </div>

        </BasicPage>
    )
}